import { render, staticRenderFns } from "./ProductRelocationsPage.vue?vue&type=template&id=4d657566&"
import script from "./ProductRelocationsPage.vue?vue&type=script&lang=ts&"
export * from "./ProductRelocationsPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports